webpackJsonp([271672481657514],{

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BannerTitle = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_BannerTitle.SetBannerTitle, { value: 'Careers' }),
	    _react2.default.createElement(
	      'div',
	      { className: 'services-content' },
	      _react2.default.createElement(
	        'section',
	        { className: 'divided-section-content' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Career Form here'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-about-careers-js-d183db509c61ae265f8b.js